import $ from 'jquery';

// Booking pages sit under a fixed header, so the body needs padding equal to its height.
// This applies to every page-booking view, not just the work page, so it is kept in the
// main pack rather than alongside the work page controllers.
export default function initBookingPageHeader() {
  if (typeof window.Application === 'undefined') {
    window.Application = {};
  }

  window.Application.adjustPageToFitHeader = function () {
    $('body.page-booking').css('padding-top', $('.fixed-header').height());
  };

  $(window).on('resize', window.Application.adjustPageToFitHeader).trigger('resize');
}
